export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11066.82dffd41.jpg";